import { useEffect, useState } from 'react';

export const useHeaderHeight = () => {
  const [headerHeight, setHeaderHeight] = useState(70);

  useEffect(() => {
    const headerElement = document.querySelector('[data-testid="Header"]');
    if (!headerElement) return;

    const observer = new ResizeObserver(([entry]) => {
      if (entry.contentRect) {
        setHeaderHeight(entry.contentRect.height);
      }
    });

    observer.observe(headerElement);

    setHeaderHeight(headerElement.getBoundingClientRect().height);

    return () => {
      observer.disconnect();
    };
  }, []);

  return headerHeight;
};
